{
	"$schema": "../../../../node_modules/@eva-design/dss/schema/schema-customization.json",
	"version": 1.0,
	"strict": {
		"text-font-family": "Poppins-Regular",
		"text-font-size": 17,
		"text-font-weight": "400",
		"text-line-height": 27,

		"text-paragraph-1-font-size": 15,
		"text-paragraph-1-font-weight": "600",
		"text-paragraph-1-font-family": "Poppins-SemiBold",
		"text-paragraph-1-line-height": 22,

		"text-paragraph-2-font-size": 16,
		"text-paragraph-2-font-weight": "500",
		"text-paragraph-2-font-family": "Poppins-Medium",
		"text-paragraph-2-line-height": 27,

		"text-heading-1-font-size": 32,
		"text-heading-1-font-weight": "700",
		"text-heading-1-font-family": "Poppins-Bold",
		"text-heading-1-line-height": 48,

		"text-heading-2-font-size": 24,
		"text-heading-2-font-weight": "700",
		"text-heading-2-font-family": "Poppins-Bold",
		"text-heading-2-line-height": 36,

		"text-heading-3-font-size": 20,
		"text-heading-3-font-weight": "700",
		"text-heading-3-font-family": "Poppins-Bold",
		"text-heading-3-line-height": 36,

		"text-heading-4-font-size": 20,
		"text-heading-4-font-weight": "600",
		"text-heading-4-font-family": "Poppins-SemiBold",
		"text-heading-4-line-height": 30,

		"text-heading-5-font-size": 18,
		"text-heading-5-font-weight": "600",
		"text-heading-5-font-family": "Poppins-SemiBold",
		"text-heading-5-line-height": 27,

		"text-heading-6-font-size": 16,
		"text-heading-6-font-weight": "500",
		"text-heading-6-font-family": "Poppins-Medium",
		"text-heading-6-line-height": 20,

		"text-subtitle-1-font-size": 17,
		"text-subtitle-1-font-weight": "500",
		"text-subtitle-1-font--family": "Poppins-Medium",
		"text-subtitle-1-line-height": 27,

		"text-subtitle-2-font-size": 15,
		"text-subtitle-2-font-weight": "500",
		"text-subtitle-2-font--family": "Poppins-Medium",
		"text-subtitle-2-line-height": 20
	},
	"components": {
		"Text": {
			"appearances": {
				"hint": {
					"mapping": {
						"color": "color-hint-500"
					}
				}
			}
		},
		"Tooltip": {
			"appearances": {
				"default": {
					"mapping": {
						"borderRadius": 12,
						"paddingHorizontal": 8,
						"paddingVertical": 8,
						"backgroundColor": "#D9D8D2",
						"indicatorBackgroundColor": "#D9D8D2",
						"borderWidth": 0,
						"textColor": "text-primary-color"
					}
				}
			}
		},
		"CheckBox": {
			"appearances": {
				"default": {
					"mapping": {
						"width": 30,
						"height": 30,
						"iconWidth": 14,
						"iconHeight": 14
					}
				}
			}
		}
	}
}
